import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../Api/CommonApi";
import { api } from "../../Api/AuthApi";

// Auth

export const signup = createAsyncThunk(
  "signup",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.Signup, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const signin = createAsyncThunk(
  "signin",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.Login, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const get_login_user_details = createAsyncThunk(
  "get_login_user_details",
  async () => {
    return await ApiGetNoAuth(api.get_login_user_details)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const verify_OTP = createAsyncThunk(
  "verify_OTP",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.verify_OTP, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const resend_OTP = createAsyncThunk(
  "resend_OTP",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.resend_OTP, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const reset_password = createAsyncThunk(
  "reset_password",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.reset_password, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const change_password = createAsyncThunk(
  "change_password",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.change_password, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const request_password_reset = createAsyncThunk(
  "request_password_reset",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.request_password_reset, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const request_delete_user = createAsyncThunk(
  "request_delete_user",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.request_delete_user, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const fileUpload = createAsyncThunk(
  "fileUpload",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.FileUpload, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const filesUpload = createAsyncThunk(
  "filesUpload",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.FilesUpload, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const getSkills = createAsyncThunk(
  "getSkills",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.getSkills, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const get_all_user_by_type = createAsyncThunk(
  "get_all_user_by_type",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.get_all_user_by_type, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const get_user_by_id = createAsyncThunk(
  "get_user_by_id",
  async (id: string, { rejectWithValue }) => {
    return await ApiGetNoAuth(`${api.get_user_by_id}/${id}`)
      .then((res) => {
        return res?.data;
      })
      .catch((err) => rejectWithValue(err));
  }
);

export const update_profile = createAsyncThunk(
  "update_profile",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.update_profile, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const get_customer_fields = createAsyncThunk(
  "get_customer_fields",
  async () => {
    return await ApiGetNoAuth(api.get_customer_fields)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const update_customer_fields = createAsyncThunk(
  "update_customer_fields",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.update_customer_fields, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const get_location_from_zipcode = createAsyncThunk(
  "get_location_from_zipcode",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.get_location_from_zipcode, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const update_driver_version = createAsyncThunk(
  "update_driver_version",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.update_driver_version, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const update_mealy_version = createAsyncThunk(
  "update_mealy_version",
  async (body: unknown) => {
    return await ApiPostNoAuth(api.update_mealy_version, body)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const get_driver_version = createAsyncThunk(
  "get_driver_version",
  async () => {
    return await ApiGetNoAuth(api.get_driver_version)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const get_mealy_version = createAsyncThunk(
  "get_mealy_version",
  async () => {
    return await ApiGetNoAuth(api.get_mealy_version)
      .then(async (res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);